/* global Autodesk */
// AutodeskViewer.jsx
import React, { useEffect, useRef } from 'react';

const AutodeskViewer = ({ urn, getFreshToken, onError }) => {
  const viewerRef = useRef(null);

  useEffect(() => {
    // Função para inicializar o viewer
    const initializeViewer = () => {
      const options = {
        env: 'AutodeskProduction',
        getAccessToken: (onGetAccessToken) => {
          // Usa a função passada para obter um token novo/válido
          getFreshToken().then(accessToken => {
            onGetAccessToken(accessToken.access_token, accessToken.expires_in);
          });
        }
      };

      Autodesk.Viewing.Initializer(options, () => {
        const viewer = new Autodesk.Viewing.GuiViewer3D(viewerRef.current);
        viewer.start();
        const documentId = 'urn:' + urn;
        Autodesk.Viewing.Document.load(
          documentId,
          (doc) => {
            let viewable = doc.getRoot().getDefaultGeometry();
            if (!viewable) {
              const all3D = Autodesk.Viewing.Document.getSubItemsWithProperties(
                doc.getRoot(),
                { type: 'geometry', role: '3d' },
                true
              );
              if (all3D && all3D.length > 0) {
                viewable = all3D[0];
              }
            }
            if (!viewable) {
              if (onError) onError({ code: 'NO_GEOMETRY', message: 'Nenhuma geometria 3D encontrada no manifest.' });
              return;
            }
            viewer.loadDocumentNode(doc, viewable);
          },
          (code, message, errors) => {
            if (onError) {
              onError({ code, message, errors });
            } else {
              // fallback log
              // eslint-disable-next-line no-console
              console.error('Forge Document.load error:', code, message, errors);
            }
          }
        );
      });
    };

    // Garante que o script do Viewer esteja carregado antes de inicializar
    if (window.Autodesk) {
      initializeViewer();
    } else {
      const script = document.createElement('script');
      script.src = 'https://developer.api.autodesk.com/modelderivative/v2/viewers/7.*/viewer3D.min.js';
      script.onload = initializeViewer;
      document.head.appendChild(script);

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://developer.api.autodesk.com/modelderivative/v2/viewers/7.*/style.min.css';
      document.head.appendChild(link);
    }

    // Limpeza (opcional, mas bom para SPAs)
    return () => {
      if (window.Autodesk && viewerRef.current?.viewer) {
        viewerRef.current.viewer.finish();
      }
      // Autodesk.Viewing.shutdown(); // Cuidado com este em SPAs
    };
  }, [urn, getFreshToken]);

  return <div ref={viewerRef} style={{ width: '100%', height: '700px', position: 'relative' }} />;
};

export default AutodeskViewer;